<template>
  <section>
    <Header></Header>
    <div class="content_wrap">
      <div class="content_box">
        <img src="/static/images/paysuccess.png" alt="">
        <p class="p_status">支付成功！</p>
        <p class="p_tip">{{time}}秒后 将返回官网首页</p>
        <p class="p_btn" @click="handBack"><span>立即返回</span></p>
      </div>
    </div>
    <Footer></Footer>
  </section>
</template>
<script>
import Footer from '../components/common/footer'
import Header from '../components/common/header'
export default {
  name: 'home',
  components: { Footer, Header },
  data () {
    return {
      time:3,
    }
  },
  created(){
    let state=this;
    setTimeout(() => {
      this.$router.push({path: '/'});
    }, 3000);
    const interval = window.setInterval(() => {
      if (state.time-- <= 0) {
        state.time = 3
        window.clearInterval(interval)
      }
    }, 1000)
  },
  methods:{
    handBack(){
      this.$router.push({path: '/'});
    }
  }
}
</script>
<style lang="less" scoped>
*{
  font-family:PingFangSC-Regular,PingFang SC;
}
.content_wrap{
  width: 100%;
  background: #F5F5F5;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  .content_box{
    width: 71.5%;
    height: 790px;
    margin: 0 auto;
    background: #ffffff;
    text-align: center;
    margin: 40px auto;
    img{
      width: 197px;
      margin-top: 106px;
    }
    .p_status{
      color: #333333;
      line-height: 46px;
      font-size: 32px;
      font-weight: 500;
    }
    .p_tip{
      color: #333333;
      line-height: 30px;
      font-size: 22px;
      margin: 20px 0 50px;
    }
    .p_btn{
      color: #333333;
      line-height: 46px;
      font-size: 32px;
      font-weight: 500;
      cursor: pointer;
      span{
        display: inline-block;
        width: 224px;
        height: 70px;
        line-height: 70px;
        background: #4566F5;
        border-radius: 9px;
        color: #ffffff;
        font-size: 22px;
      }
    }
  }
}
@media (min-width: 1024px){
  .content_wrap{
    width: 100%;
    border-top: 0.01rem solid transparent;
    border-bottom: 0.01rem solid transparent;
    background: #F5F5F5;
    .content_box{
      width: 71.5%;
      height: 6.4rem;
      margin: 0 auto;
      text-align: center;
      margin: 0.4rem auto;
      img{
        width: 1.97rem;
        margin-top: 1.06rem;
      }
      .p_status{
        color: #333333;
        line-height: 0.46rem;
        font-size: 0.32rem;
        font-weight: 500;
      }
      .p_tip{
        color: #333333;
        line-height: 0.3rem;
        font-size: 0.22rem;
        margin: 0.2rem 0 0.5rem;
      }
      .p_btn{
        color: #333333;
        line-height: 0.46rem;
        font-size: 0.32rem;
        font-weight: 500;
        cursor: pointer;
        span{
          display: inline-block;
          width: 2.24rem;
          height: 0.7rem;
          line-height: 0.7rem;
          background: #4566F5;
          border-radius: 0.09rem;
          color: #ffffff;
          font-size: 0.22rem;
        }
      }
    }
  }
}
@media (min-width: 1680px) {
  .content_wrap{
    width: 100%;
    background: #F5F5F5;
    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;
    .content_box{
      width: 71.5%;
      height: 790px;
      margin: 0 auto;
      background: #ffffff;
      text-align: center;
      margin: 40px auto;
      img{
        width: 197px;
        margin-top: 106px;
      }
      .p_status{
        color: #333333;
        line-height: 46px;
        font-size: 32px;
        font-weight: 500;
      }
      .p_tip{
        color: #333333;
        line-height: 30px;
        font-size: 22px;
        margin: 20px 0 50px;
      }
      .p_btn{
        color: #333333;
        line-height: 46px;
        font-size: 32px;
        font-weight: 500;
        cursor: pointer;
        span{
          display: inline-block;
          width: 224px;
          height: 70px;
          line-height: 70px;
          background: #4566F5;
          border-radius: 9px;
          color: #ffffff;
          font-size: 22px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/paySuccess.vue